import styled from 'styled-components/macro';
import {variables} from 'theme/variables';

const {
  app_header_height,
} = variables;

export const GalleryWrapper = styled.div`
  flex-shrink: 0;
  // min-width: 280px;
`


export const Thumbnail = styled.div`
  width: ${(props) => props.large ? '70px' : '40px'};
  height: ${(props) => props.large ? '70px' : '40px'};
  overflow: hidden;
  margin: 3px;
`

export const Thumbnails = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;
`

